export default {
  props: {
    loadingGrafico: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      chaveSelecionada: null,
      dadosDesativados: false
    };
  },
  watch: {
    loadingGrafico() {
      if (this.loadingGrafico) {
        this.graficoRef.showLoading();
        return;
      }

      this.graficoRef.hideLoading();
    }
  },
  methods: {
    graficoCarregado() {
      this.$nextTick().then(() => {
        this.chaveSelecionada = null;
        this.dadosDesativados = false;
        this.salvarRef();
      });
    },
    salvarRef() {
      if (this.$refs["grafico"] === undefined) return;
      this.graficoRef = this.$refs["grafico"].chart;
    }
  }
};
